import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type { Feature } from '../feature'

export const triggerLoadingOnContextChange = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    meFeature.contexts.selectors.zoneContext.asObservable.pipe(
      rxjs.filter(TypeChecker.isNotNullish.raw),
      rxjs.switchMap(() =>
        rxjs.from([
          feature.actions.getAssignments
            .from('triggerLoadingOnContextChange (effect)')
            .create(),
          feature.actions.getOutcomes
            .from('triggerLoadingOnContextChange (effect)')
            .create(),
          feature.actions.getUnits
            .from('triggerLoadingOnContextChange (effect)')
            .create(),
        ]),
      ),
    ),
)
